/** The Velinko mark: a blue message bubble with a white V and a green "synced" dot. */
export function Logo({ size = 28 }: { size?: number }): JSX.Element {
  return (
    <svg width={size} height={size} viewBox="26 28 56 53" aria-hidden="true" focusable="false">
      <path
        fill="#3B82F6"
        d="M38,28 H70 A12,12 0 0 1 82,40 V60 A12,12 0 0 1 70,72 H47 L35,81 V71.3 A12,12 0 0 1 26,60 V40 A12,12 0 0 1 38,28 Z"
      />
      <path
        fill="none"
        stroke="#FFFFFF"
        strokeWidth="8"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M39,41 L51,61 L63,41"
      />
      <circle cx="71" cy="57" r="4.5" fill="#22C55E" />
    </svg>
  );
}
